"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditInventory = void 0;
const barcode_1 = require("client/components/barcode");
const confirmation_modal_1 = require("client/components/confirmation-modal");
const icons_1 = require("client/components/icons");
const button_1 = require("client/components/material/button");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const select_1 = require("client/components/material/select");
const switch_1 = require("client/components/material/switch");
const text_field_1 = require("client/components/material/text-field");
const menu_1 = require("client/components/menu");
const router_1 = require("client/components/router");
const ui_1 = require("client/components/ui");
const callable_1 = require("client/components/ui/callable");
const distributor_pricing_1 = require("client/modules/inventory-order/components/distributor-pricing");
const store_1 = require("client/modules/inventory-order/store");
const diagnosis_list_1 = require("client/modules/kitchen-sink/diagnosis-list");
const store_2 = require("client/modules/sites/modules/sites-detail/store");
const store_3 = require("client/modules/users/store");
const html5sortable_es_js_1 = require("lib/html5sortable.es.js");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const ramda_1 = require("ramda");
const React = require("react");
const react_1 = require("react");
const throttle_debounce_1 = require("throttle-debounce");
const store_4 = require("../../../inventory-list/store");
const store_5 = require("../../store");
const diagnosis_select_1 = require("./diagnosis-select");
require("./edit-inventory.less");
const material_ui_1 = require("material-ui");
const core_1 = require("@material-ui/core");
const moment = require("moment");
const permissions_1 = require("../../../../../../../shared/permissions");
const ui_2 = require("../../../../../../components/ui");
const dummyInventory = {
    addToAllSites: false,
    barCode: "",
    claimQuantity: "0",
    daysSupply: 0,
    defaultSig: "",
    defaultSig2: "",
    defaultSig3: "",
    group: "",
    id: 0,
    inventoryCodes: [],
    levelAlert: 0,
    levelWarn: 0,
    ndc: "",
    price: 0,
    priceAWP: 0,
    priceCash: 0,
    priority: 0,
    refills: 0,
    type: "",
    typeICD10s: "",
    disQty: 0
};
const quantityToRunColumns = [
    {
        label: "Quantity To Run",
        id: "runOrder"
    },
    {
        label: "ERX Quantity",
        id: "erxQuantity"
    }
];
/** @description Inventory details edit component; renders JSX. */
let EditInventory = class EditInventory extends react_1.Component {
    constructor() {
        /*
         * -----------------------------------------------------------------
         * ----------========== REGION: Data Management ==========----------
         * -----------------------------------------------------------------
         */
        super(...arguments);
        this.units = [
            {
                id: 1,
                label: "GM",
                value: "GM"
            },
            {
                id: 2,
                label: "ML",
                value: "ML"
            },
            {
                id: 3,
                label: "EA",
                value: "EA"
            }
        ];
        /*
         * -------------------------------------------------------------
         * ----------========== REGION: Observables ==========----------
         * -------------------------------------------------------------
         */
        this.drugReferenceUrl = "";
        this.ischanged = false;
        this.order = "ASC";
        this.orderBy = "order.status";
        this.clickedElement = "";
        this.filterText = "";
        this.filterDate = "";
        this.justSaved = false;
        this.icd10sListChanged = store_5.inventoryDetailStore.icd10sListHasChanged;
        this.claimQuantityHasChanged = false;
        this.useOverrideHasChanged = false;
        this.initialClaimQuantity = "";
        this.initialUseOverride = false;
        this.originalPricesHasChanged = false;
        this.editingClaimQuantity = false;
        this.showGroupModal = false;
        this.showPriorityModal = false;
        this.groupInventory = [];
        this.groupList = [];
        this.textField = "";
        this.priorityInv = [];
        this.useOverride = false;
        this.siteName = "";
        this.showConfirmationEditInventorySave = false;
        this.erxQtys = [];
        this.startingErxQuantity = 0;
        this.inventoryDistributors = [];
        this.inventorySite = null;
        this.claimQuantites = "";
        this.isActionLogs = false; //E-086
        this.isLoading = false; //E-086
        this.actionLogsData = []; //E-086
        this.inventoryQuantity = {
            quantityOnHand: 0,
            min: 0,
            max: 0
        };
        this.distributor = {
            defaultDistributorId: null,
            defaultDistributorOverrideId: null
        };
        this.inventoryMarkUpMargin = "";
        this.changeDetected = false;
        this.siteId = 0;
        /**
         * @description Pulls matching ICD10s from the Couchbase DB.
         * @param value Input string to query.
         * @returns void
         */
        this.handleSearch = throttle_debounce_1.debounce(200, (value) => {
            store_5.inventoryDetailStore.loadICD10s(value);
        });
        // E-086.1 E-086.2
        this.action_header = {
            color: "#101010",
            fontSize: "14px",
            padding: 0
        };
        // E-086.3
        this.main_table = {
            marginLeft: -95
        };
        this.action_not_found = {
            margin: "22px",
            fontSize: "15px",
            color: "#ff1c1c",
            fontWeight: "500",
        };
        this.table_th = {
            fontSize: "14px",
            padding: 0,
        };
        /**
         * @author TK
         * @description Handles the group text field on blur event -- closes the group list.
         * @returns void
         */
        this.handleGroupOnBlur = () => {
            this.showGroupModal = false;
        };
        // E-086
        this.handleActionLogToggle = async (inventoryId) => {
            this.isLoading = true;
            const { actionLogs, success, } = await store_5.inventoryDetailStore.readactionlog(inventoryId);
            store_5.inventoryDetailStore.setActionLogs(success);
            if (success) {
                store_5.inventoryDetailStore.setActionLogs(true, actionLogs);
                this.isLoading = false;
                this.isActionLogs = true;
            }
        };
        this.transitionToWarnings = () => {
            router_1.RouteManager.transitionTo(`/formulary/warnings/${this.siteId}/${this.inventory.id}`);
        };
        this.transitionToInformation = () => {
            router_1.RouteManager.transitionTo(`/formulary/information/${this.siteId}/${this.inventory.id}`);
        };
        /*
         * ------------------------------------------------------------------
         * ----------========== REGION: Component Render ==========----------
         * ------------------------------------------------------------------
         */
        /**
         * @author TK
         * @description Renders the group list drop down. Group list displayed reflects
         * user input in the group text field.
         *
         * Implemented using MaterialUI <Menu /> component. The list gets passed to
         * the data attribute of <Menu />.
         * @returns JSX Element
         */
        this.renderGroupSelect = () => {
            const inventory = this.inventory;
            const groups = this.groupList.filter(group => group !== "" &&
                group.toLowerCase().includes(inventory.group.toLowerCase()));
            const data = groups.map(i => ({
                id: i,
                label: `${i}`,
                value: i.toString()
            }));
            return (React.createElement(menu_1.Menu, { className: "group", data: data, showMenu: this.showGroupModal, onAction: row => {
                    this.showGroupModal = false;
                    this.textField = row.label;
                    this.inventory.group = this.textField;
                } },
                React.createElement("a", { className: "menu-component__input", onClick: () => (this.showGroupModal = true) },
                    React.createElement(text_field_1.MaterialTextField, { className: "group", label: "Group", onChange: this.handleFilterGroupList, onBlur: this.handleGroupOnBlur, value: inventory.group || "" }))));
        };
        this.handleUseOverrideToggle = () => {
            this.useOverride = !this.useOverride;
            if (this.useOverride !== this.initialUseOverride) {
                this.useOverrideHasChanged = true;
            }
            else {
                this.useOverrideHasChanged = false;
            }
        };
        /*!!*
         * @author MD
         * @description Renders the drag-and-drop priority menu.
         * @returns JSX Element
         */
        this.renderPriorityModal = () => {
            const editable = this.useOverride && this.writeAccess;
            setTimeout(() => {
                if (editable) {
                    html5sortable_es_js_1.sortable(".avastye", {
                        itemSerializer: (serializedItem, sortableContainer) => ({
                            position: serializedItem.index + 1,
                            html: serializedItem.html
                        }),
                        placeholderClass: "internal-priority"
                    });
                }
            }, 100);
            const availableItems = this.loadAvailableItems();
            const listItems = availableItems.length > 0
                ? availableItems
                : this.groupInventory.sort((a, b) => a.priority - b.priority);
            return (React.createElement("div", null,
                React.createElement("ol", { className: "avastye" }, listItems.map((item, index) => (React.createElement("li", { key: index, className: "avastye--item", onMouseDown: () => {
                        if (!this.useOverrideHasChanged) {
                            this.useOverrideHasChanged = true;
                            this.forceUpdate();
                        }
                    } },
                    editable && "☰",
                    " ",
                    React.createElement("b", null, item.strengthDescription || item.name),
                    " (",
                    item.package,
                    ")"))))));
        };
        this.handleToggleInventoryBackorder = () => {
            this.inventory.isBackorder = !this.inventory.isBackorder;
        };
        this.getReferenceUrl = async () => {
            let unpaddedInventoryPkg = this.unpadInventoryPkg(this.inventory.package || "", false, true, false);
            let setIdFound = await store_5.inventoryDetailStore.getSetIdFromPkg(unpaddedInventoryPkg);
            // second attempt
            if (!setIdFound) {
                unpaddedInventoryPkg = this.unpadInventoryPkg(this.inventory.package || "", false, true, true);
                setIdFound = await store_5.inventoryDetailStore.getSetIdFromPkg(unpaddedInventoryPkg);
            }
            // third attempt
            if (!setIdFound) {
                unpaddedInventoryPkg = this.unpadInventoryPkg(this.inventory.package || "", false, false, false);
                setIdFound = await store_5.inventoryDetailStore.getSetIdFromPkg(unpaddedInventoryPkg);
            }
            // fourth attempt
            if (!setIdFound) {
                unpaddedInventoryPkg = this.unpadInventoryPkg(this.inventory.package || "", true, true, true);
                setIdFound = await store_5.inventoryDetailStore.getSetIdFromPkg(unpaddedInventoryPkg);
            }
            if (setIdFound) {
                this.drugReferenceUrl = `https://dailymed.nlm.nih.gov/dailymed/drugInfo.cfm?setid=${setIdFound}`;
            }
        };
        this.removePaddedZeros = (num) => {
            const numLocal = num.split("");
            while (numLocal[0] === "0") {
                numLocal.shift();
            }
            return numLocal.join("");
        };
        this.unpadInventoryPkg = (pkg, unpadFirst = false, unpadSecond = false, unpadThird = false) => {
            const [first = "", second = "", third = ""] = pkg.split("-");
            const unpaddedInventoryPkg = [
                unpadFirst ? this.removePaddedZeros(first) : first,
                unpadSecond ? this.removePaddedZeros(second) : second,
                unpadThird ? this.removePaddedZeros(third) : third
            ].join("-");
            return unpaddedInventoryPkg;
        };
        /**
         * @author TK
         * @description Check string is not a zero, ignoring non-numeric values
         */
        this.hasZeroString = (value) => {
            const normalizedValue = value.replace(/\D+/g, "");
            const isZero = normalizedValue === "0";
            const containsZero = value &&
                typeof value === "string" &&
                Boolean(value.split(",").find(el => Number(el.trim()) === 0));
            return isZero || containsZero;
        };
        this.isValidEditQty = () => {
            const normalizedEditQty = parseFloat(String(this.inventory.disQty));
            const isGreaterThanZero = normalizedEditQty > 0;
            return isGreaterThanZero;
        };
        /**
         * @author MD
         * @description this.inventory.claimQuantity is being saved and pulled as
         * a string that will then be parsed as an array. This function returns
         * the string with a mandatory join character; comma by default.
         * @param joinChars The character to be used for an array join.
         * @returns Returns a string that can be processed to an array.
         */
        this.inventoryCleanString = (joinChars = ",") => {
            const cq = this.inventory.claimQuantity;
            if (!cq) {
                return "0";
            }
            const sortedClaimQuantity = cq
                .split(",")
                .map((x) => (isFinite(x) ? Number(x) : x))
                .sort((a, b) => b - a);
            const uniqueSortredClaimQuantity = new Set(sortedClaimQuantity);
            const claimQuantity = Array.from(uniqueSortredClaimQuantity).join(joinChars);
            return claimQuantity.length > 0 ? claimQuantity : "0";
        };
        /**
         * @description Checks the inventory argument to ensure it's valid.
         * @param inventory Inventory item that matches the IInventory interface.
         * @returns boolean - True as long as the inventory is valid.
         */
        this.isValid = (inventory) => Boolean(inventory.barCode &&
            inventory.claimQuantity &&
            !this.hasZeroString(inventory.claimQuantity) &&
            this.isValidEditQty() &&
            inventory.daysSupply &&
            inventory.levelAlert.toString() &&
            inventory.levelWarn.toString() &&
            inventory.price.toString() &&
            inventory.priceCash.toString() &&
            inventory.priceAWP.toString() &&
            inventory.priority.toString() &&
            inventory.refills.toString());
        /**
         * @desc Runs an initial load stack from the store for data.
         * @returns void;
         */
        this.loadData = async () => {
            await this.loadStores();
            await this.loadGroups();
            await this.loadPriorities();
            await this.loadAvailableDistributors();
        };
        this.loadAvailableDistributors = async () => {
            console.info("inside loadavaialbledistribuotros");
            const query = {
                inventoryId: this.inventory.id,
                all: true
            };
            await store_1.inventoryOrderStore.loadAvailableDistributors(query);
            console.info("asdfasdfasfdsf", store_1.inventoryOrderStore.availableBackorderDistributors);
        };
        /**
         * @description Loads the data from the mobx stores.
         * @returns void
         */
        this.loadGroups = async () => {
            const invGroups = store_4.inventoryListStore.inventoryGroups.value;
            // The group of the current inventory viewing
            this.defaultGroup = this.inventory.group;
            // The inventories in the group.
            this.groupInventory =
                store_4.inventoryListStore.inventory.value
                    .filter(storage => storage.group === this.inventory.group)
                    .map(inventory => inventory.children)[0] || [];
            if (this.defaultGroup !== this.inventory.group) {
                this.groupInventory.push(this.inventory);
            }
            // An array of all the intentory groups
            this.groupList = invGroups
                ? invGroups.map((inventoryGroup) => inventoryGroup.group)
                : [];
        };
        /**
         * @description
         * @returns void
         */
        this.loadPriorities = async () => {
            const [siteIdFromParam] = this.props.params;
            try {
                const siteId = store_3.usersStore.permissions.ReadPharmacies
                    ? Number(siteIdFromParam)
                    : store_3.usersStore.user.value.site.id;
                if (siteId !== 0) {
                    await store_2.sitesDetailStore.readSite(siteId);
                    const site = store_2.sitesDetailStore.site.value;
                    const siteInv = [...site.inventories];
                    const groupInvIds = this.groupInventory.map(el => el.id);
                    const matchingInv = siteInv.filter((el) => groupInvIds.includes(el.inventoryId));
                    /**
                     * If the site group already uses an override, sort the groupInventory
                     * to reflect the existing state.
                     */
                    if (matchingInv.length > 0) {
                        this.priorityInv = matchingInv;
                        if (matchingInv.length === groupInvIds.length) {
                            this.groupInventory = this.groupInventory.sort((a, b) => {
                                const aPriority = a.sites.find((siteA) => siteA.siteId === siteId).priorityOverride;
                                const bPriority = b.sites.find((siteB) => siteB.siteId === siteId).priorityOverride;
                                return aPriority < bPriority ? -1 : 1;
                            });
                        }
                    }
                    this.siteName = site.displayName;
                }
            }
            catch (e) {
                console.error(`Catch: loadPriorities has thrown an error:\n\n${e}`);
            }
        };
        /**
         * @description Loads the data from the mobx stores.
         * @returns void
         */
        this.loadStores = async () => {
            const query = { start: 0, count: 1000 };
            await store_4.inventoryListStore.loadInventory(query);
            await store_4.inventoryListStore.loadInventoryGroup(query);
        };
        /**
         * @description Loads and returns the items available to the current pharm in this group.
         * @returns Array of inventory objects that are accessable to the pharmacy.
         */
        this.loadAvailableItems = () => {
            let availableItems = [];
            try {
                const activeIds = this.priorityInv.map((inventorysite) => inventorysite.inventoryId);
                availableItems = this.groupInventory.filter((item) => activeIds.includes(item.id));
            }
            catch (e) {
                console.error(`Catch: renderPriority has thrown an error.\n\n${e}`);
            }
            return availableItems;
        };
        /**
         * @description
         * @returns
         */
        // private testValuesState = () => toJS(inventoryDetailStore.icd10sList);
        this.testValuesState = () => {
            const icd10sList = store_5.inventoryDetailStore.icd10List;
            return mobx_1.toJS(icd10sList);
        };
        /*
         * ----------------------------------------------------------------
         * ----------========== REGION: Event Handlers ==========----------
         * ----------------------------------------------------------------
         */
        this.handleDistributorSelect = (distributorSelected) => {
            this.changeDetected = true;
            this.distributor = Object.assign(Object.assign({}, this.distributor), { defaultDistributorOverrideId: distributorSelected.id });
        };
        /**
         * @description Manages the action behind clicking the cancel button.
         * @returns void
         */
        this.handleCancel = () => {
            this.props.onCancel();
        };
        /**
         * @description Manages the selection of changing diagnosis codes.
         * @returns void
         */
        this.handleChangeDiagnosisSelect = (values) => {
            this.inventory.typeICD10s = values.map(value => value.value).join(",");
        };
        /**
         * @description Manages the state of a string input change.
         * @returns void
         */
        this.handleChangeString = (fieldName) => (event, value) => {
            // Remember, No Negatives.
            if (fieldName === "daysSupply" ||
                fieldName === "refills" ||
                // fieldName === "disQty" ||
                fieldName === "levelAlert" ||
                fieldName === "levelWarn") {
                if (value.search(/\d/g))
                    return;
            }
            this.inventory[fieldName] = value;
            if (fieldName === "claimQuantity") {
                this.claimQuantityHasChanged =
                    this.initialClaimQuantity !== this.inventory.claimQuantity;
                // console.group("------");
                // console.log("this.initialClaimQuantity", this.initialClaimQuantity);
                // console.log("this.inventory.claimQuantity", this.inventory.claimQuantity);
                // console.groupEnd();
            }
            // Check for price changes.
            if (fieldName === "price" ||
                fieldName === "priceCash" ||
                fieldName === "priceAWP") {
                if (this.inventory[fieldName] !== this.initialPrices[fieldName]) {
                    this.originalPricesHasChanged = true;
                }
                else {
                    this.originalPricesHasChanged = false;
                }
            }
        };
        this.handleChangeUnit = (value) => {
            this.inventory.unit = value;
        };
        this.handleChangeQuantity = (fieldName) => (event, value) => {
            this.changeDetected = true;
            if (fieldName === "min" || fieldName === "max") {
                if (value.search(/\d/g))
                    return;
            }
            if (value === "") {
                this.inventoryQuantity[fieldName] = value;
            }
            else {
                this.inventoryQuantity[fieldName] = parseFloat(value);
            }
        };
        this.handleChangeMarkUpMargin = (event, value) => {
            this.changeDetected = true;
            this.inventoryMarkUpMargin = value;
        };
        /**
         * @description
         * @returns void
         */
        this.handleDelete = () => {
            callable_1.callable(this.props.onDelete)(this.inventory);
        };
        /**
         * @author MD
         * @description Manages the save state of priority overrides.
         * @param useOverride Boolean value stating whether override was enabled.
         * @returns void
         */
        this.handleOverride = async (useOverride) => {
            const availableIds = this.loadAvailableItems().map((item) => item.id);
            const inventoryChanges = [];
            const changedItemsUnfiltered = await this.handlePriorityState();
            const changedItems = changedItemsUnfiltered.filter((item) => item.priorityOverride);
            changedItems.forEach((item) => {
                if (availableIds.includes(item.id)) {
                    const inventorysite = mobx_1.toJS(item.sites).find((inventorysite) => inventorysite.siteId === this.siteId);
                    inventorysite.priorityOverride = item.priorityOverride;
                    inventoryChanges.push(inventorysite);
                }
            });
            for (const inventorysite of inventoryChanges) {
                inventorysite.useOverride = useOverride ? true : false;
                await store_5.inventoryDetailStore.saveSitePriorities(inventorysite);
            }
        };
        /**
         * @author MD
         * @description Manages the save state of priorities based on the management
         * modal. Inventory is stored as objects in the this.groupInventory observable
         * array. The priority list managed in the modal is handled by the sortable()
         * package and when serialized it converts the list to an object. Our data
         * (priority and name) are then extracted, matched to an existing inventory
         * item, then passed to the handle save method.
         * @returns An array containing the inventory items inside of the active group.
         */
        this.handlePriorityState = () => {
            this.groupInventory =
                store_4.inventoryListStore.inventory.value
                    .filter(storage => storage.group === this.inventory.group)
                    .map(inventory => inventory.children)[0] || [];
            if (this.defaultGroup !== this.inventory.group) {
                this.groupInventory.push(this.inventory);
            }
            // const rawList: ISortableList[] = sortable(".avastye", "serialize");
            let rawList = [];
            try {
                rawList = html5sortable_es_js_1.sortable(".avastye", "serialize");
            }
            catch (err) {
                console.error("error in serializing", err);
            }
            const rawListItems = rawList && rawList[0] ? rawList[0].items : [];
            const mappedData = rawListItems.map(item => {
                const rawHtml = item.html;
                const ndcRegex = /(\d){5}-(\d){4}-(\d){2}/;
                const ndc = ndcRegex.exec(rawHtml)[0];
                return { ndc, priority: item.position };
            });
            const newPriorities = this.groupInventory.map((item) => {
                try {
                    const match = mappedData.find(mappedData => item.package === mappedData.ndc);
                    if (match)
                        item.priorityOverride = match.priority;
                }
                catch (e) {
                    console.error(`An error was thrown while mapping new priorities.\n\n${e}`);
                }
                return item;
            });
            return newPriorities;
        };
        /**
         * @description Manages the submit button for inventory submissions and edits.
         * @returns void
         */
        this.handleSubmit = async () => {
            if (!this.isValid(this.inventory)) {
                // Inventory is invalid.
                this.missing = {
                    barCode: !this.inventory.barCode,
                    // editQty: !this.isValidEditQty(),
                    claimQuantity: !this.inventory.claimQuantity ||
                        (this.inventory.claimQuantity &&
                            this.hasZeroString(this.inventory.claimQuantity)),
                    daysSupply: !this.inventory.daysSupply,
                    levelAlert: this.inventory.levelAlert.toString() === "",
                    levelWarn: this.inventory.levelWarn.toString() === "",
                    price: !this.inventory.price,
                    priceCash: !this.inventory.priceCash,
                    priceAWP: !this.inventory.priceAWP,
                    priority: this.inventory.priority.toString() === "",
                    refills: !this.inventory.refills,
                    disQty: !this.isValidEditQty()
                    // disQty: !this.inventory.disQty
                };
            }
            else {
                // Inventory is valid.
                this.inventory.claimQuantity = this.inventoryCleanString(",");
                const inventory = ramda_1.merge(this.inventory, {
                    price: this.inventory.price,
                    priceCash: this.inventory.priceCash,
                    priceAWP: this.inventory.priceAWP,
                    inventoryCodes: mobx_1.toJS(store_5.inventoryDetailStore.icd10List) || [],
                    inventoryQuantity: this.inventoryQuantity,
                    inventoryMarkUpMargin: this.inventoryMarkUpMargin,
                    distributor: this.distributor,
                    activeSiteId: this.siteId,
                    disQty: this.inventory.disQty ? this.inventory.disQty : 0
                });
                if (this.siteId !== 0) {
                    try {
                        await this.handleOverride(this.useOverride);
                    }
                    catch (err) {
                        console.error("Error caught in handleOverride", err);
                    }
                }
                this.justSaved = true;
                store_5.inventoryDetailStore.setICD10sChangedToFalse();
                console.info("inventory is ", inventory);
                callable_1.callable(this.props.onSave)(inventory);
                this.editingClaimQuantity = !this.editingClaimQuantity;
            }
            // Start Region: Convert states for isChanged to monitor new triggers.
            if (this.originalPricesHasChanged) {
                this.originalPricesHasChanged = false;
            }
            if (this.claimQuantityHasChanged) {
                this.claimQuantityHasChanged = false;
            }
            if (this.useOverrideHasChanged) {
                this.useOverrideHasChanged = false;
            }
            // End Region
            this.showConfirmationEditInventorySave = false;
            this.changeDetected = false;
        };
        /**
         * @description Manages the state of the "Add to all sites" button toggle.
         * @returns void
         */
        this.handleToggle = () => {
            this.inventory = ramda_1.merge(this.inventory, {
                addToAllSites: !this.inventory.addToAllSites
            });
        };
        /**
         * @author TK
         * @description Monitors the page for changes and toggles the save button.
         * @returns Boolean based on whether something has changed.
         */
        this.isChanged = () => {
            const c1 = Object.entries(ramda_1.merge(this.inventory, {
                price: +this.inventory.price,
                priceCash: +this.inventory.priceCash,
                priceAWP: +this.inventory.priceAWP
            }));
            const c2 = Object.entries(ramda_1.merge(ramda_1.merge(dummyInventory, this.props.inventory), {
                price: +this.inventory.price,
                priceCash: +this.inventory.priceCash,
                priceAWP: +this.inventory.priceAWP
            }));
            const result = ramda_1.difference(c1, c2).filter(res => res[0] !== "inventoryCodes" && res[0] !== "claimQuantity");
            // console.group("isChanged logs");
            // console.log("result", result);
            // console.log("result.length > 0", result.length > 0);
            // console.log(
            //   "inventoryDetailStore.icd10sListHasChanged",
            //   inventoryDetailStore.icd10sListHasChanged
            // );
            // console.log("this.originalPricesHasChanged", this.originalPricesHasChanged);
            // console.log("this.changeDetected", this.changeDetected);
            // console.log("this.claimQuantityHasChanged", this.claimQuantityHasChanged);
            // console.log("this.useOverrideHasChanged", this.useOverrideHasChanged);
            // console.groupEnd();
            return (result.length > 0 ||
                store_5.inventoryDetailStore.icd10sListHasChanged ||
                this.originalPricesHasChanged ||
                this.changeDetected ||
                this.claimQuantityHasChanged ||
                this.useOverrideHasChanged);
        };
        /**
         * @author TK
         * @description Update the value of this.inventory['group'] on text change.
         * Make sure the filtered group list is displaying.
         *
         * Converts the group name to uppercase.
         * @returns void
         */
        this.handleFilterGroupList = (event, value) => {
            this.inventory.group = value.toUpperCase();
            if (!this.showGroupModal) {
                this.showGroupModal = true;
            }
        };
        this.renderQuantities = () => {
            const testList = this.inventory.claimQuantity.split(",").map(qty => ({
                runQty: Number(qty),
                disQty: Number(qty) * this.inventory.disQty
            }));
            return (React.createElement(list_1.MaterialList, { columns: quantityToRunColumns, order: "ASC", orderBy: "", rows: testList, renderRow: this.renderQuantityToRun }));
        };
        this.renderQuantityToRun = (quantity, index) => (React.createElement(list_item_1.MaterialListItem, { key: index },
            React.createElement(list_item_text_1.MaterialListItemText, { primary: quantity.runQty }),
            React.createElement(list_item_text_1.MaterialListItemText, { primary: quantity.disQty })));
    }
    /**
     * @author AH
     * @description Gets the available icd10s options from inventoryDetailStore.
     * if exist, otherwise set to empty array.
     * @returns ICD10s Options
     */
    get availableOptions() {
        const icd10sValue = store_5.inventoryDetailStore.icd10s.value;
        let icd10sOptions;
        if (icd10sValue) {
            icd10sOptions = icd10sValue
                .filter((icd10) => {
                if (typeof this.inventory.typeICD10s === "string") {
                    return this.inventory.typeICD10s.indexOf(icd10.icd10) < 0;
                }
                return false;
            })
                .map((icd10, i) => {
                const icd10Object = icd10["dispensify-icd10"];
                return {
                    id: icd10Object.id,
                    label: `${icd10Object.icd10} ${icd10Object.shortDesc}`,
                    value: icd10Object.icd10,
                    tokenLabel: icd10Object.icd10
                };
            });
        }
        return icd10sOptions;
    }
    /*
     * -------------------------------------------------------
     * ----------========== REGION: React ==========----------
     * -------------------------------------------------------
     */
    componentWillMount() {
        const [siteId] = this.props.params;
        this.siteId = Number(siteId);
        this.writeAccess = store_3.usersStore.permissions.UpdateFormulary;
        this.inventory = ramda_1.merge(dummyInventory, this.props.inventory);
        this.inventory = ramda_1.merge(this.inventory, {
            price: Number(this.inventory.price).toFixed(2),
            priceCash: Number(this.inventory.priceCash).toFixed(2),
            priceAWP: Number(this.inventory.priceAWP).toFixed(2)
        });
        store_5.inventoryDetailStore.refreshState();
        store_5.inventoryDetailStore.loadICD10s();
        this.missing = {
            barCode: false,
            claimQuantity: false,
            daysSupply: false,
            levelAlert: false,
            levelWarn: false,
            price: false,
            priceCash: false,
            priceAWP: false,
            priority: false,
            refills: false,
            disQty: false
        };
    }
    async componentDidMount() {
        await this.loadData();
    }
    // E-086
    componentWillUnmount() {
        store_5.inventoryDetailStore.setActionLogs(false, []);
    }
    componentWillReceiveProps(props) {
        const siteId = store_3.usersStore.permissions.ReadMaster
            ? this.siteId
            : store_3.usersStore.user.value.site.id;
        this.loadPriorities();
        if (props.inventory) {
            this.inventory = ramda_1.merge(dummyInventory, props.inventory);
            const toFixedPrices = {
                price: Number(this.inventory.price).toFixed(2),
                priceCash: Number(this.inventory.priceCash).toFixed(2),
                priceAWP: Number(this.inventory.priceAWP).toFixed(2)
            };
            this.inventory = ramda_1.merge(this.inventory, toFixedPrices);
            this.initialPrices = toFixedPrices;
            if (this.inventory &&
                this.inventory.sites &&
                this.inventory.sites.length) {
                // loop through sites and initialize inventory with data from inventorysite
                for (const site of this.inventory.sites) {
                    if (site.siteId === siteId) {
                        this.useOverride = Boolean(site.useOverride);
                        this.initialUseOverride = this.useOverride;
                        this.inventory.price = site.price;
                        this.inventory.priceCash = site.priceCash;
                        this.inventory.claimQuantity =
                            site.claimQuantity || this.inventory.claimQuantity;
                        this.initialClaimQuantity = this.inventory.claimQuantity; // For isChanged
                        this.inventoryQuantity = Object.assign(Object.assign({}, this.inventoryQuantity), { quantityOnHand: site.quantity, min: site.min || 0, max: site.max || 0 });
                        this.distributor = Object.assign(Object.assign({}, this.distributor), { defaultDistributorOverrideId: site.defaultDistributorOverrideId, defaultDistributorId: site.defaultDistributorId });
                        this.inventoryMarkUpMargin = site.markUpMargin;
                        break;
                    }
                }
            }
            this.getReferenceUrl();
        }
    }
    /*
     * -------------------------------------------------------------
     * ----------========== REGION: Main Render ==========----------
     * -------------------------------------------------------------
     */
    render() {
        const inventory = this.inventory || dummyInventory;
        const claimQuantity = this.inventoryCleanString(" ⇢ ");
        const groupExists = this.groupList.indexOf(this.inventory.group) !== -1;
        const actionLogsTracking = store_5.inventoryDetailStore === null || store_5.inventoryDetailStore === void 0 ? void 0 : store_5.inventoryDetailStore.actionsLogs; //E-086
        // const showQuantityOnHand: boolean = inventoryListStore.activePharm !== 0;
        const showQuantityOnHand = this.siteId !== 0;
        return (React.createElement("div", { className: "edit-inventory" },
            React.createElement(ui_1.UiForm, { buttons: this.writeAccess && [
                    React.createElement(button_1.MaterialButton, { style: { display: this.siteId !== 0 && inventory.disQty !== 0 ? "none" : null }, disabled: !store_3.usersStore.permissions.DestroyFormulary, className: "btnDelete", onClick: this.handleDelete }, inventory.deletedAt === null ? "DISABLE" : "ENABLE"),
                    React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, this.justSaved ? "Back" : "CANCEL"),
                    "Save",
                ], loading: this.props.loading, isChanged: this.isChanged, status: this.props.status, saved: "Saved", 
                // onSubmit={() => this.showConfirmationEditInventorySave = true}
                onSubmit: this.handleSubmit, error: this.props.error },
                React.createElement("div", { className: "main" },
                    React.createElement("h3", null, "IDENTIFICATION"),
                    React.createElement("div", { className: "identification-info" },
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "type-info" },
                                React.createElement("div", { className: "type-info__column ndc" },
                                    React.createElement("div", { className: "label text" }, "NDC"),
                                    React.createElement("div", { className: "value" }, inventory.package)),
                                React.createElement("div", { className: "type-info__column refndc" },
                                    React.createElement("div", { className: "label text" }, "Ref. NDC"),
                                    React.createElement("div", { className: "value" }, inventory.ndc)),
                                React.createElement("div", { className: "type-info__column name" },
                                    React.createElement("div", { className: "label text" }, "Name"),
                                    React.createElement("div", { className: "value" }, inventory.strengthDescription || inventory.name)),
                                React.createElement("div", { className: "type-info__column generic" },
                                    React.createElement("div", { className: "label text" }, "Generic"),
                                    React.createElement("div", { className: "value" }, inventory.generic)))),
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "type-info" },
                                React.createElement("div", { className: "type-info__column manufacturer" },
                                    React.createElement("div", { className: "label text" }, "Manufacturer"),
                                    React.createElement("div", { className: "value" }, inventory.labeler)),
                                React.createElement("div", { className: "type-info__column manufacturer" },
                                    React.createElement("div", { className: "label text" }, "DailyMed Reference"),
                                    React.createElement("div", { className: "value" }, this.drugReferenceUrl ? (React.createElement("a", { href: this.drugReferenceUrl, target: "__blank" }, "View")) : (React.createElement(material_ui_1.Typography, null, "No Drug Ref")))),
                                React.createElement("div", { className: "type-info__column type" },
                                    React.createElement("div", { className: "label text" }, "Type"),
                                    React.createElement("div", { className: "value" }, inventory.dosage)),
                                React.createElement("div", { className: "type-info__column form" },
                                    React.createElement("div", { className: "label text" }, "Form"),
                                    React.createElement("div", { className: "value" }, inventory.route)),
                                React.createElement("div", { className: "type-info__column form" },
                                    React.createElement("div", { className: "label text" }, "Description"),
                                    React.createElement("div", { className: "value" }, inventory.description || "Unavailable")))),
                        React.createElement("div", { className: "row" },
                            React.createElement(text_field_1.MaterialTextField, { className: "barcode", label: "Barcode *", missing: this.missing.barCode, onChange: this.handleChangeString("barCode"), value: `${inventory.barCode}` || "", disabled: !this.writeAccess }),
                            this.inventory.barCode && (React.createElement("div", { className: "print-barcode" },
                                React.createElement(barcode_1.UiBarcode, { background: "transparent", displayValue: false, height: 50, lineColor: "#26324e", value: inventory.barCode, margin: 0 })))),
                        React.createElement("div", { className: "row" },
                            React.createElement(text_field_1.MaterialTextField, { className: "days-supply", label: "Days Supply *", missing: this.missing.daysSupply, onChange: this.handleChangeString("daysSupply"), type: "number", value: inventory.daysSupply.toString() || "", disabled: !this.writeAccess }),
                            React.createElement(text_field_1.MaterialTextField, { className: "refills", label: "Refills *", missing: this.missing.refills, onChange: this.handleChangeString("refills"), type: "number", value: inventory.refills.toString() || "", disabled: !this.writeAccess }),
                            React.createElement(text_field_1.MaterialTextField, { className: "edit-qty", label: "Edit Qty", missing: this.missing.disQty, 
                                // required
                                onChange: this.handleChangeString("disQty"), type: "number", 
                                // value={Number(inventory.disQty).toFixed(2) || ""}
                                value: String(inventory.disQty) || "", disabled: !this.writeAccess }),
                            React.createElement(select_1.MaterialSelect, { options: this.units, className: "edit-unit", label: "Select Unit *", required: true, searchable: true, 
                                // onSelect={this.handleChangeUnit}
                                onSelect: this.handleChangeUnit, value: inventory.unit || "", disabled: !this.writeAccess })),
                        React.createElement("div", { className: "row" },
                            this.siteId ? (React.createElement(text_field_1.MaterialTextField, { className: "claim-quantity", label: "Master Run Qty", type: "string", value: this.props.inventory
                                    ? this.props.inventory.claimQuantity
                                    : "", disabled: Boolean("Vim is life") })) : null,
                            React.createElement(text_field_1.MaterialTextField, { className: "claim-quantity", label: "Qty to Run *", missing: this.missing.claimQuantity, onChange: this.handleChangeString("claimQuantity"), type: "string", value: inventory.claimQuantity || "", disabled: !this.writeAccess })),
                        React.createElement("div", { className: "quantity-dispensing-container" }, this.renderQuantities()))),
                React.createElement("div", { className: "main" },
                    React.createElement("h3", null, "GROUPING"),
                    React.createElement("div", { className: "identification-info" },
                        React.createElement("div", { className: "row" },
                            React.createElement("div", null,
                                React.createElement("div", null, (this.siteName && groupExists && (React.createElement("p", null,
                                    "This item's priority is based on the",
                                    " ",
                                    React.createElement("b", null, this.useOverride
                                        ? `${this.siteName} pharmacy override`
                                        : `master formulary defaults`),
                                    "."))) ||
                                    (this.siteName && (React.createElement("p", null, "This product does not belong to a group."))) ||
                                    (store_3.usersStore.permissions.ReadMaster && (React.createElement("p", null,
                                        "You are viewing an item in the master formulary. Group management can be toggled on the",
                                        " ",
                                        React.createElement("a", { href: "/formulary" }, "master formulary page.")))) || React.createElement("p", null, "Item is loading.")),
                                groupExists && this.writeAccess && this.siteName && (React.createElement(switch_1.MaterialSwitch
                                // checked={this.useOverride}
                                , { 
                                    // checked={this.useOverride}
                                    checked: this.useOverride, label: "Use pharmacy override", 
                                    // value="1"
                                    value: "Use Priority", onChange: this.handleUseOverrideToggle, disabled: !groupExists || this.inventory.group === "" })),
                                groupExists && (React.createElement("div", { className: "group__wrapper" },
                                    React.createElement("div", { className: "group__wrapper--block" },
                                        React.createElement("h2", null, "Master Defaults"),
                                        React.createElement("span", null,
                                            React.createElement("b", null, "Drug:"),
                                            " ",
                                            inventory.strengthDescription || inventory.name),
                                        React.createElement("br", null),
                                        React.createElement("span", null,
                                            React.createElement("b", null, "Group:"),
                                            " ",
                                            inventory.group || "None"),
                                        " ",
                                        React.createElement("br", null),
                                        React.createElement("span", null,
                                            React.createElement("b", null, "Priority:"),
                                            " ",
                                            inventory.priority > 0
                                                ? groupExists
                                                    ? inventory.priority
                                                    : "None"
                                                : "None")),
                                    React.createElement("div", { className: ((this.useOverride || !this.siteName) &&
                                            "group__wrapper--block") ||
                                            "group__wrapper--block group__wrapper--block-disabled" },
                                        (this.siteName && (React.createElement("h2", null,
                                            this.siteName,
                                            " Priority Override (",
                                            this.useOverride ? (React.createElement("span", { className: "group__wrapper--enabled" }, "Enabled")) : ("Disabled"),
                                            ")"))) || React.createElement("h2", null, "Priorities"),
                                        this.renderPriorityModal()))))))),
                store_3.usersStore.permissions.ReadAllFormulary && (React.createElement("div", { className: "main" },
                    React.createElement("h3", null, "CLAIM PRICING"),
                    React.createElement("div", { className: "pricing-info" },
                        React.createElement("div", { className: "row" },
                            React.createElement(text_field_1.MaterialTextField, { className: "price", label: "FDB Average Price ", missing: this.missing.priceAWP, leftItem: React.createElement(icons_1.DollarsIcon, null), onChange: this.handleChangeString("priceAWP"), type: "text", numType: "price", value: inventory.priceAWP || "", disabled: !store_3.usersStore.permissions.UpdatePrices || !!this.siteName }),
                            React.createElement(text_field_1.MaterialTextField, { className: "price", label: "Cash Price ", missing: this.missing.priceCash, leftItem: React.createElement(icons_1.DollarsIcon, null), onChange: this.handleChangeString("priceCash"), type: "text", numType: "price", value: this.inventorySite
                                    ? this.inventorySite.priceCash
                                    : inventory.priceCash || "", disabled: !store_3.usersStore.permissions.UpdatePrices })),
                        store_3.usersStore.user &&
                            store_3.usersStore.user.value &&
                            store_3.usersStore.user.value.siteUser && (React.createElement("div", { className: "row" },
                            React.createElement(text_field_1.MaterialTextField, { className: "price", label: "Mark Up Margin %", 
                                // missing={this.missing.priceAWP}
                                onChange: this.handleChangeMarkUpMargin, type: "number", numType: "price", value: this.inventoryMarkUpMargin, disabled: !store_3.usersStore.permissions.UpdatePrices })))))),
                this.siteId ? (React.createElement("div", { className: "main" },
                    React.createElement("h3", null, "COST"),
                    React.createElement("div", { className: "pricing-info" },
                        React.createElement("div", { className: "row" },
                            React.createElement(text_field_1.MaterialTextField, { className: "price", label: "Cost ", missing: this.missing.price, leftItem: React.createElement(icons_1.DollarsIcon, null), 
                                // onChange={this.handleChangeString("price")}
                                type: "text", numType: "price", value: this.inventorySite
                                    ? this.inventorySite.price
                                    : Number(inventory.price).toFixed(2) || "", 
                                // disabled={!usersStore.permissions.UpdatePrices}
                                disabled: true })),
                        React.createElement("div", { className: "row" },
                            React.createElement(distributor_pricing_1.DistributorPricing, { onSelect: this.handleDistributorSelect, inventoryDistributors: this.inventory.inventoryDistributors, siteDistributors: this.inventory.siteDistributors, defaultDistributorOverrideId: this.distributor.defaultDistributorOverrideId, defaultDistributorId: this.distributor.defaultDistributorId }))))) : null,
                showQuantityOnHand && ( // No need to see this on master.
                React.createElement("div", { className: "main" },
                    React.createElement("h3", null, "QUANTITY"),
                    React.createElement("div", { className: "pricing-info" },
                        React.createElement("div", { className: "row" },
                            React.createElement(text_field_1.MaterialTextField, { className: "price", label: "Quantity on hand", onChange: this.handleChangeQuantity("quantityOnHand"), type: "number", value: this.inventoryQuantity.quantityOnHand, disabled: !this.writeAccess })),
                        React.createElement("div", { className: "row" },
                            React.createElement(text_field_1.MaterialTextField, { className: "price", label: "Minimum", missing: this.missing.price, onChange: this.handleChangeQuantity("min"), type: "number", value: this.inventoryQuantity.min, disabled: !this.writeAccess }),
                            React.createElement(text_field_1.MaterialTextField, { className: "price", label: "Maximum", missing: this.missing.priceCash, onChange: this.handleChangeQuantity("max"), type: "number", value: this.inventoryQuantity.max, disabled: !this.writeAccess }))))),
                !this.siteId && (React.createElement("div", { className: "main" },
                    React.createElement("h3", null, "BACKORDER"),
                    React.createElement("div", { className: "pricing-info" },
                        React.createElement("div", { className: "row" },
                            React.createElement(switch_1.MaterialSwitch, { checked: Boolean(inventory.isBackorder), label: "Is on backorder", value: "backorder", onChange: this.handleToggleInventoryBackorder })),
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "formulary-backorder-list" },
                                React.createElement(list_1.MaterialList, { columns: [
                                        { id: "1", label: "distributor" },
                                        { id: "2", label: "status" }
                                    ], rows: store_1.inventoryOrderStore.availableBackorderDistributors || [], renderRow: (dist) => {
                                        console.info(dist);
                                        const pid = dist.purchaseInventoryDistributor.find((pid) => pid.inventoryId === this.inventory.id);
                                        const isBackorder = pid && pid.backorderExpectedDate;
                                        return (React.createElement(list_item_1.MaterialListItem, null,
                                            React.createElement(list_item_text_1.MaterialListItemText, { primary: dist.distributor }),
                                            React.createElement(list_item_text_1.MaterialListItemText, { primary: isBackorder ? "backorder" : "available", className: `formulary-backorder-list__status--${isBackorder ? "backorder" : "available"}` })));
                                    } })))))),
                React.createElement("div", { className: "main" },
                    React.createElement("h3", null, "SETTINGS"),
                    React.createElement("div", { className: "settings-info" },
                        React.createElement("div", { className: "settings-top" },
                            React.createElement("div", { className: "settings-left" },
                                React.createElement("div", { className: "row" }, this.writeAccess && (React.createElement(diagnosis_select_1.UiDiagnosisSelect, { className: "defaults__long", label: "Diagnosis Codes", options: this.availableOptions, values: "", 
                                    // was supposed to be an array of diagnosis to populate the multi-select.
                                    onChange: values => this.handleChangeDiagnosisSelect(values), onSearch: this.handleSearch }))))),
                        React.createElement(diagnosis_list_1.DiagnosisCodeList, { rowData: this.testValuesState() }),
                        React.createElement("div", { className: "settings-top" },
                            React.createElement("div", { className: "settings-left" },
                                React.createElement("h4", null, "INVENTORY ALERTS"),
                                React.createElement("div", { className: "row" },
                                    React.createElement(text_field_1.MaterialTextField, { className: "defaults__normal margined", label: "Low stock alert *", missing: this.missing.levelAlert, onChange: this.handleChangeString("levelAlert"), type: "number", value: inventory.levelAlert.toString() || "", disabled: !this.writeAccess }),
                                    React.createElement(text_field_1.MaterialTextField, { className: "defaults__normal margined", label: "Low stock warn *", missing: this.missing.levelWarn, onChange: this.handleChangeString("levelWarn"), type: "number", value: inventory.levelWarn.toString() || "", disabled: !this.writeAccess })),
                                React.createElement("div", { className: "manual" },
                                    React.createElement(ui_1.UiButton, { primary: true, onClick: this.transitionToWarnings }, "Label Warnings"),
                                    React.createElement("span", { style: { marginLeft: "20px" } }),
                                    React.createElement(ui_1.UiButton, { primary: true, onClick: this.transitionToInformation }, "Label Information"))),
                            React.createElement("div", { className: "settings-right" },
                                React.createElement("h4", null, "RX SIG"),
                                React.createElement("div", { className: "row" },
                                    React.createElement(text_field_1.MaterialTextField, { className: "defaults__long", label: "SIG 1", onChange: this.handleChangeString("defaultSig"), value: `${inventory.defaultSig}` || "", disabled: !this.writeAccess })),
                                React.createElement("div", { className: "row" },
                                    React.createElement(text_field_1.MaterialTextField, { className: "defaults__long", label: "SIG 2", onChange: this.handleChangeString("defaultSig2"), value: `${inventory.defaultSig2}` || "", disabled: !this.writeAccess })),
                                React.createElement("div", { className: "row" },
                                    React.createElement(text_field_1.MaterialTextField, { className: "defaults__long", label: "SIG 3", onChange: this.handleChangeString("defaultSig3"), value: `${inventory.defaultSig3}` || "", disabled: !this.writeAccess })))),
                        React.createElement("div", { className: "settings-bottom" }, store_3.usersStore.permissions.ReadMaster && (React.createElement(React.Fragment, null,
                            React.createElement("h4", null, "PHARMACY AVAILABILITY"),
                            React.createElement("div", { className: "row" },
                                React.createElement(switch_1.MaterialSwitch, { checked: inventory.addToAllSites, label: "Automatically add to all pharmacies", value: "1", onChange: this.handleToggle, disabled: !this.writeAccess }))))),
                        store_3.usersStore.user.value.groupId === permissions_1.GROUPS.ADMIN ||
                            store_3.usersStore.user.value.groupId === permissions_1.GROUPS.DEV ? (React.createElement("div", null,
                            (inventory === null || inventory === void 0 ? void 0 : inventory.ndc) !== "" && (React.createElement("div", null, this.isActionLogs ? (React.createElement(button_1.MaterialButton, { className: "primary", onClick: () => {
                                    this.isActionLogs = false;
                                    this.isLoading = false;
                                    store_5.inventoryDetailStore.setActionLogs(false);
                                } }, "Hide Tracking")) : (React.createElement(button_1.MaterialButton, { className: "primary", onClick: () => this.handleActionLogToggle(inventory.id) }, "View Tracking")))),
                            this.isLoading ? (React.createElement("div", { style: { marginTop: 15 } },
                                React.createElement(ui_2.UiLoadingIndicator, null))) : null,
                            store_5.inventoryDetailStore.isActionLogs && (React.createElement("div", { style: this.main_table },
                                React.createElement(core_1.Table, { "aria-label": "simple table" },
                                    React.createElement(core_1.TableHead, null,
                                        React.createElement(core_1.TableRow, null,
                                            React.createElement(core_1.TableCell, { style: this.action_header, align: "right" },
                                                React.createElement("strong", null, "Date & Time")),
                                            React.createElement(core_1.TableCell, { style: this.action_header, align: "right" },
                                                React.createElement("strong", null, "Action")),
                                            React.createElement(core_1.TableCell, { style: this.action_header, align: "right" },
                                                React.createElement("strong", null, "User")))),
                                    store_5.inventoryDetailStore.isActionLogs && (React.createElement(core_1.TableBody, null, (actionLogsTracking === null || actionLogsTracking === void 0 ? void 0 : actionLogsTracking.length) > 0 ? (actionLogsTracking === null || actionLogsTracking === void 0 ? void 0 : actionLogsTracking.map((action) => {
                                        var _a, _b;
                                        return (React.createElement(core_1.TableRow, { key: action.id },
                                            React.createElement(core_1.TableCell, { component: "th", scope: "row", style: this.table_th }, moment(action.date).format("MM/DD/YYYY HH:mm")),
                                            React.createElement(core_1.TableCell, { align: "right", style: this.table_th }, action.action),
                                            React.createElement(core_1.TableCell, { align: "right", style: this.table_th }, `${(_a = action.user) === null || _a === void 0 ? void 0 : _a.firstName} ${(_b = action.user) === null || _b === void 0 ? void 0 : _b.lastName}`)));
                                    })) : (React.createElement("div", { style: this.action_not_found }, "No Action Logs Found"))))))))) : null))),
            this.showConfirmationEditInventorySave && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Save", cancelText: "Cancel", message: `Please confirm save. <br />Do you want to save the edited inventory?`, onCancel: () => (this.showConfirmationEditInventorySave = false), onConfirm: this.handleSubmit, title: "Save confirmation" }))));
    }
};
__decorate([
    mobx_1.computed
], EditInventory.prototype, "availableOptions", null);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "drugReferenceUrl", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "inventory", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "ischanged", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "missing", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "clickedElement", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "filterDate", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "justSaved", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "icd10sListChanged", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "claimQuantityHasChanged", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "useOverrideHasChanged", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "initialPrices", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "initialClaimQuantity", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "initialUseOverride", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "originalPricesHasChanged", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "editingClaimQuantity", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "showGroupModal", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "showPriorityModal", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "groupInventory", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "groupList", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "textField", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "defaultGroup", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "writeAccess", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "priorityInv", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "useOverride", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "siteName", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "showConfirmationEditInventorySave", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "erxQtys", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "startingErxQuantity", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "inventoryDistributors", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "inventorySite", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "claimQuantites", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "isActionLogs", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "isLoading", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "actionLogsData", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "inventoryQuantity", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "distributor", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "inventoryMarkUpMargin", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "changeDetected", void 0);
__decorate([
    mobx_1.observable
], EditInventory.prototype, "siteId", void 0);
EditInventory = __decorate([
    mobx_react_1.observer
], EditInventory);
exports.EditInventory = EditInventory;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-detail/components/edit-inventory/edit-inventory.tsx
// module id = 3469
// module chunks = 0